"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReadyForUser = exports.calculateIconState = void 0;
const next_utils_enums_colors_1 = require("@gerenciatd/next.utils.enums.colors");
const constants_1 = require("../../constants");
const utils_1 = require("../../utils");
/* ITEMS QUE NO DEBEN APARECER CON USUARIO TELCO */
const TELCOL_ID_TO_REMOVE = [
    'notifications',
    'profile',
    'login',
    'out'
];
/* ITEMS QUE DEBEN DE APARECER COMO MORE_OPTIONS */
const LEGADO_ID_FOR_OPTIONS = [
    'support',
    'profile',
    'informes',
    'averias',
    'offers',
];
/**
 * Retorna un objecto con las propiedades que debe tomar un elemento de actionBottomBar en función
 * de: segment, id propio, id seleccionado, ispriority
 * @param {string} segment Segmento en el que se está ejecutando la cabecera
 * @param {string} titleBarId Id propio del elemento del menú
 * @param {string} actionBarIdSelected Id seleccionado del menú
 * @param {boolean} isPriority El usuario es priority
 * @returns {
 *  iconColor, // color del icono
 *  labelColor, // color del literal
 *  kind, // trazo del icono
 *  isSelected // marca si esta seleccionado
 * }
 */
const calculateIconState = (segment, titleBarId, actionBarIdSelected, isPriority, isGestor) => {
    let iconColor = next_utils_enums_colors_1.COLOR_DICTIONARY.GREY4.toLowerCase();
    let labelColor = next_utils_enums_colors_1.COLOR_DICTIONARY.GREY4.toLowerCase();
    let kind = 'l';
    const isSelected = titleBarId === actionBarIdSelected;
    // Siempre cambia el color del icono y el color del literal
    if (isSelected) {
        iconColor = next_utils_enums_colors_1.COLOR_DICTIONARY.BLUE.toLowerCase();
        labelColor = next_utils_enums_colors_1.COLOR_DICTIONARY.BLUE.toLowerCase();
        kind = 's';
    }
    if (segment === constants_1.PARTICULARES && isPriority && !isGestor && isSelected) {
        iconColor = next_utils_enums_colors_1.COLOR_DICTIONARY.BLUE_DARK.toLowerCase();
        labelColor = next_utils_enums_colors_1.COLOR_DICTIONARY.BLUE_DARK.toLowerCase();
    }
    return {
        iconColor,
        labelColor,
        kind,
        isSelected,
    };
};
exports.calculateIconState = calculateIconState;
/**
 * Genera y prepara las estructuras: menu, y moreOptions, menu será la lista de elementos visibles en ActionBottomBar,
 *  y moreOptions, las que se incrustan en el modal
 * @param {Array} menu Recibe la lista con todas las posibles opciones
 * @param {string} userType Determina si esta logado, así como el tipo de usuario.
 * @param {string} segment Segmento en el que se está ejecutando la cabecera
 * @returns {menu: Array, moreOptions: Array}
 */
const getReadyForUser = (menu, userType, segment, userSegment) => {
    const result = [];
    const moreOptions = [];
    const realSegment = (0, utils_1.decideUserSegment)(userSegment, segment);
    let currentActionId = '';
    if (userType && realSegment === constants_1.PARTICULARES) {
        currentActionId = '';
        // we must remove notifications and profile
        menu.forEach((menuItem) => {
            if (menuItem && menuItem.action && menuItem.action.id) {
                currentActionId = menuItem.action.id;
            }
            if ((!menuItem.action &&
                userType === constants_1.TELCO &&
                !TELCOL_ID_TO_REMOVE.includes(currentActionId))
                || (userType === constants_1.TELCO && currentActionId === 'support')) {
                result.push(Object.assign(Object.assign({}, menuItem), { kind: 'L' }));
            }
            if (userType === constants_1.LEGADO) {
                if (!menuItem.action ||
                    !LEGADO_ID_FOR_OPTIONS.includes(currentActionId)) {
                    result.push(menuItem);
                }
                if (menuItem.action &&
                    LEGADO_ID_FOR_OPTIONS.includes(currentActionId)) {
                    moreOptions.push(Object.assign(Object.assign({}, menuItem), { kind: 'L' }));
                }
                /* if we have more options append icons with .. */
                const existOptions = result.find((item) => {
                    let res = false;
                    if (item &&
                        item.action &&
                        item.action.id &&
                        item.action.id === 'opciones') {
                        res = true;
                    }
                    return res;
                });
                if (moreOptions.length > 0 && !existOptions) {
                    result.push(constants_1.OPTION_ITEM);
                }
            }
            if (!menuItem.action && !userType) {
                result.push(Object.assign(Object.assign({}, menuItem), { kind: 'L' }));
            }
        });
    }
    const isEmpresas = realSegment === constants_1.EMPRESAS;
    if (isEmpresas) {
        currentActionId = '';
        // we must add an moreOptions items
        menu.forEach((menuItem) => {
            if (!menuItem.action ||
                !LEGADO_ID_FOR_OPTIONS.includes(currentActionId)) {
                result.push(menuItem);
            }
            if (menuItem.action &&
                LEGADO_ID_FOR_OPTIONS.includes(currentActionId)) {
                moreOptions.push(Object.assign(Object.assign({}, menuItem), { kind: 'L' }));
            }
        });
        /* if we have more options append icons with .. */
        if (moreOptions.length > 0) {
            result.push(constants_1.OPTION_ITEM);
        }
    }
    return { menu: result, moreOptions };
};
exports.getReadyForUser = getReadyForUser;
//# sourceMappingURL=utils.js.map